<script lang="ts" setup>
/**
 * トークルーム0件時の表示。
 */

import { defineProps } from "vue";

interface Props {
	/**
	 * 「トークルームが1件も投稿ない時」文言。
	 */
	talkRoomNotFoundText: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps<Props>();
</script>

<template>
	<section class="revico-community-talk-no-talkroom">{{ talkRoomNotFoundText }}</section>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	&-no-talkroom {
		margin: 40px 0;
		text-align: center;
		white-space: pre-wrap;
	}
}
</style>
